import React from 'react';
import { bonuses } from '../data/bonuses';
import { Reveal } from './Reveal';
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-16" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-17" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-18" data-mp="vuh863qwaqh9">
          <div className="inline-flex rounded-full bg-brand-coral/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-coral" data-id="element-19" data-mp="qtt8yusij3by">
            DZIŚ W PAKIECIE GRATIS
          </div>
          <h2 className="mt-4 text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-20" data-mp="zuhltm666xn9">
            🎁 5 Ekskluzywnych Bonusów
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-21" data-mp="1eiujqootiqke">
            O wartości <span className="font-bold text-brand-navy line-through" data-id="element-22" data-mp="19jrdx210kgbd">199 zł</span> — dziś gratis, bez
            dodatkowych kosztów.
          </p>
        </div>
        <div className="space-y-3" data-id="element-23" data-mp="1nhzinw4aklx3">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-navy/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-24" data-mp="1jk1sor2p5vsn" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-navy font-display font-black text-white" data-id="element-25" data-mp="3tsfdkpt63byj">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Okładka bonusu: ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-26" data-mp="7ma4yc2941qc" />
              <div className="min-w-0 flex-1" data-id="element-27" data-mp="lcdmipq6r79g">
                <h3 className="font-display text-base font-black uppercase leading-snug tracking-tight text-brand-navy" data-id="element-28" data-mp="lcnbc9zhv8dk">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs" data-id="element-29" data-mp="vb2vft03thdk">
                  <span className="text-brand-gray" data-id="element-30" data-mp="v86wq2gfmoo2">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-gray line-through" data-id="element-31" data-mp="109w5tck3gs9i">wartość {bonus.price}</span>
                  <span className="ml-2 font-extrabold text-brand-coral" data-id="element-32" data-mp="alihozcv8sqc">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}